export default __webpack_public_path__ + "static/media/logo-complex-boss-mobile.d757edcc.png";